import context from '@/context'
import getComponentKey from '@/utils/getComponentKey'
import { allowErrorDialog } from '@/utils/fetch'

export const initialState = {
  fetching: false,
  saving: false,
  formKey: getComponentKey(),
  jobPositionPermissions: null
}

export const actionTypes = {
  Fetching: 'jobPositionAssignmentPermission/fetching',
  Fetched: 'jobPositionAssignmentPermission/fetched',
  Saving: 'jobPositionAssignmentPermission/saving',
  Saved: 'jobPositionAssignmentPermission/saved',
  Error: 'jobPositionAssignmentPermission/error'
}

export const actionCreators = {
  getPermissions: (jobAssignmentId) => (dispatch) => {
    dispatch({ type: actionTypes.Fetching })
    context.api.jobPositionService.getJobPositionAssignmentPermissions(jobAssignmentId, allowErrorDialog)
      .then(response => dispatch({ type: actionTypes.Fetched, data: response }))
      .catch(() => dispatch({ type: actionTypes.Error, update: { fetching: false } }))
  },
  savePermissions: (payload) => (dispatch) => {
    dispatch({ type: actionTypes.Saving })
    context.api.jobPositionService.saveJobPositionAssignmentPermissions(payload, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.Saved })
        dispatch(actionCreators.getPermissions(payload.jobAssignmentId))
      })
      .catch(() => dispatch({ type: actionTypes.Error, update: { saving: false } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.Fetching: return { ...state, fetching: true }
    case actionTypes.Fetched: return { ...state, fetching: false, jobPositionPermissions: action.data, formKey: getComponentKey() }
    case actionTypes.Saving: return { ...state, saving: true }
    case actionTypes.Saved: return { ...state, saving: false }
    case actionTypes.Error: return { ...state, ...action.update }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/JobPositionPermissions.js